import { useEffect, useState } from 'react';
import '../styles/ProgressDialog.css'
import arrowDown from '../images/arrow-down.svg'
import editIcon from '../images/edit-icon.svg'
import Skeleton from '@material-ui/lab/Skeleton';
import { useFetch } from '../hooks/useFetch';
import StudentInfoSkeleton from './StudentInfoSkeleton';
import { useCookies } from 'react-cookie';
import EditStudentInfoDialog from './EditStudentInfoDialog';

interface StudentInfoProps {
    id: string;
    openEditInfo: boolean;
    setOpenEditInfo: (value: boolean) => void;
}
export interface StudentInfomation {
    id: string,
    code: string,
    curriculumTh: string,
    curriculumEn: string,
    plan: string,
    description: string,
    year: number,
    no: number,
    title: string,
    firstName: string,
    lastName: string,
    email: string,
    mobile: string,
    lineId: string,
    note: string,
    advisor: string,
    advisorOffice: string,
    coAdvisor: string,
    proposalDate: string,
    studentStatusId: number,
    studentStatus: string,
}

export default function StudentInfo({ id, openEditInfo, setOpenEditInfo }: StudentInfoProps) {

    const [cookies, setCookie] = useCookies(['user'])
    const [seeMore, setSeeMore] = useState(false);


    const handleSeeMore = () => {
        setSeeMore(!seeMore);
    }

    const onClickEdit = () => {
        setOpenEditInfo(true)
    }

    const { data: getStudentData } = useFetch({
        url: `/Students/${id}`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    }, openEditInfo)

    const [studentInfomation, setStudentInfomation] = useState<StudentInfomation>()

    useEffect(() => {
        if (getStudentData) {
            setStudentInfomation(getStudentData)
        }
    }, [getStudentData])

    const changeDateFormat = (date: string) => {
        if (date === null) {
            return null
        }
        const newDate = new Date(date)
        return newDate.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'Asia/Bangkok'
        })
    }

    return (
        <div>

            {
                studentInfomation ? (
                    <div>
                        <div className="ProgressDialog-header">
                            <div>
                                {
                                    studentInfomation ? (
                                        <p className="">{studentInfomation?.plan} / {studentInfomation?.code} / {studentInfomation?.curriculumTh} - เข้าเรียน {studentInfomation?.year}/{studentInfomation?.no}</p>
                                    ) : (
                                        <Skeleton variant="text" width={300} />
                                    )
                                }
                            </div>
                        </div>
                        <div className="ProgressDialog-student-info">
                            <div className="ProgressDialog-student-container">
                                <div className="ProgressDialog-name-id-container">
                                    <div className="flex-align-center gap-dot5">
                                        <h4 className="ProgressDialog-name">{studentInfomation?.title} {studentInfomation?.firstName} {studentInfomation?.lastName}</h4>
                                        <p className="ProgressDialog-student-status">({studentInfomation?.studentStatus})</p>
                                    </div>
                                    <p className="ProgressDialog-id">{id}</p>
                                </div>
                            </div>
                            {
                                seeMore && (
                                    <div className="ProgressDialog-student-info-wrapper">
                                        <div className="ProgressDialog-student-info-container">
                                            <div className="ProgressDialog-student-info">
                                                <p>เบอร์โทร</p>
                                                <p>อีเมล</p>
                                                <p>Line ID</p>
                                                <p>อาจารย์ที่ปรึกษา</p>
                                                <p>สังกัด</p>
                                                <p>อาจารย์ที่ปรึกษาร่วม</p>
                                                <p>Proposal Date</p>
                                                <p>หมายเหตุ</p>
                                            </div>
                                            <div className="ProgressDialog-student-info">
                                                <p>{studentInfomation?.mobile || '-'}</p>
                                                <p>
                                                    <a href={`mailto:${studentInfomation?.email?.trim()}`} style={{ color: 'inherit' }}>{studentInfomation?.email || '-'}</a>
                                                </p>
                                                <p>{studentInfomation?.lineId || '-'}</p>
                                                <p>{studentInfomation?.advisor || '-'}</p>
                                                <p>{studentInfomation?.advisorOffice || '-'}</p>
                                                <p>{studentInfomation?.coAdvisor || '-'}</p>
                                                <p>{changeDateFormat(studentInfomation?.proposalDate) || '-'}</p>
                                                <p>{studentInfomation?.note || '-'}</p>
                                            </div>
                                        </div>
                                        <button className="ProgressDialog-edit-info-btn" onClick={onClickEdit}><img src={editIcon} alt="editIcon" /> Edit</button>
                                    </div>
                                )

                            }
                        </div>
                    </div>
                ) : <StudentInfoSkeleton seeMore={seeMore} />
            }
            <div className="ProgressDialog-see-more-container">
                <div className="h-line"></div>
                <button onClick={handleSeeMore}>
                    {seeMore ? 'Fold' : 'See More'}
                    <img src={arrowDown} width={18} height={18} alt="see-more-icon" className={seeMore ? 'see-more-icon active' : 'see-more-icon'} />
                </button>
                <div className="h-line"></div>
            </div>
        </div>
    )
}